<!-- Add "scoped" attribute to limit CSS to this component only -->
<template>
  <div xmlns:v-bind="http://www.w3.org/1999/xhtml">
    <p><b>Station N° </b><span>{{ stationNumber }}</span> - <span>{{ stationStatus }}</span></p>
    <p><b>Adresse : </b><span>{{ stationAddress }}</span></p>
    <p><b>Capacité : </b><span>{{ stationCapacity }}</span></p>
    <p :class="{ red: availableBikes }">
      <b>Emplacement{{ availableBikesStandPlural }}
        libre{{ availableBikesStandPlural }} : </b><span>{{ availableBikesStand }}</span>
    </p>
    <p><b>Vélo{{ availableBikesPlural }} disponible{{ availableBikesPlural }} : </b><span>{{ availableBikes }}</span></p>
  </div>
</template>
<style src="./Popup.css"></style>

<script>

  export default {
    name: 'Popup',
    props: {
      station: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        stationNumber: '',
        stationStatus: '',
        stationAddress: '',
        stationCapacity: '',
        availableBikesStand: '',
        availableBikesStandPlural: '',
        availableBikes: '',
        availableBikesPlural: ''
      }
    },
    mounted() {
      this.createPopupcontent(this.$props.station)
    },
    methods: {
      /**
       *
       * @param {{  status: String,
                    name: String,
                    number: Integer,
                    address: String,
                    bikeStands: Integer,
                    availableBikesStands: Integer,
                    availableBikes: Integer }} station
       */
      createPopupcontent(station) {
        this.stationNumber = station.number
        this.stationStatus = (station.status === 'OPEN') ? '✔' : '❌'
        this.stationAddress = station.address
        this.stationCapacity = station.bikeStands
        this.availableBikesStand = (station.availableBikesStands === 0) ? 0 : station.availableBikesStands
        this.availableBikesStandPlural = (station.availableBikesStands > 1) ? 's' : ''
        this.availableBikes = (station.availableBikes === 0) ? 0 : station.availableBikes
        this.availableBikesPlural = (station.availableBikes > 1) ? 's' : ''
      }
    },
    render: createElement => {
      return createElement('coucou')
    }
  }
</script>
